// File: src/components/ErrorBoundary.jsx
// Description: Global error boundary component to catch and display errors gracefully.

import React from 'react';
import { Container, Typography, Button } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  // Update state so the next render shows the fallback UI.
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // Log the error to an error reporting service if needed.
  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    // You can send error info to a logging service here.
  }

  handleReload = () => {
    // Reload the page to try recovering from the error.
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Something went wrong.
          </Typography>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            An unexpected error has occurred. Please try reloading the page.
          </Typography>
          <Button variant="contained" color="primary" onClick={this.handleReload}>
            Reload Page
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
